var _path, _path2, _path3, _path4, _path5, _path6, _rect, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite15Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 59,
    viewBox: "0 0 200 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.0093 42.2765C86.2281 42.2765 90.4113 39.3149 90.4113 33.9101C90.4113 29.2826 88.1901 26.5061 79.4165 24.7662C75.9366 24.0258 74.715 23.3224 74.715 21.4344V21.3974C74.715 19.8796 75.8996 18.8061 78.7872 18.8061C82.3781 18.8061 83.3776 20.583 83.5257 22.7671H89.9671C89.782 17.3253 86.3762 13.5493 78.6761 13.5493C71.2722 13.5493 67.8664 16.807 67.8664 21.3234C67.8664 25.9138 70.1616 28.209 77.3804 29.7639C82.23 30.9485 83.4886 31.5408 83.4886 33.9841C83.4886 35.8721 82.193 37.0567 79.0093 37.0567C75.0112 37.0567 73.8635 35.1317 73.8265 32.8735H67.126C67.2 38.5375 70.939 42.2765 79.0093 42.2765Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.749 19.1392C104.491 19.1392 101.752 20.583 100.234 23.9148H100.16L100.456 21.2864V13.3271H94.0887V41.6472H100.456V30.5042C100.456 27.4686 101.974 24.5071 105.491 24.5071C108.156 24.5071 109.6 26.0619 109.6 29.2086V41.6472H116.004V28.3571C116.004 21.7306 112.969 19.1392 107.749 19.1392Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.064 41.6472V19.7315H120.697V41.6472H127.064Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.341 19.1392C142.231 19.1392 139.566 20.657 138.196 23.5075H138.122L138.307 20.9162V19.7315H131.94V48.3107H138.307V40.6846L138.122 37.8711H138.159C139.529 40.7957 142.231 42.2765 145.341 42.2765C151.449 42.2765 154.078 37.8711 154.078 31.0595V30.4302C154.078 23.3965 151.449 19.1392 145.341 19.1392ZM147.71 30.9115C147.71 34.2432 146.711 36.9827 143.12 36.9827C139.381 36.9827 138.307 34.4283 138.307 31.3187V30.097C138.307 26.7282 139.64 24.396 143.12 24.396C146.674 24.396 147.71 27.3206 147.71 30.3932V30.9115Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.525 41.6472V36.6865H164.197L175.155 24.285V19.7315H156.904V24.6922H167.196L156.09 37.2788V41.6472H175.525Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.458 48.7919C187.751 47.9035 190.861 45.053 192.379 40.7217L199.857 19.7315H193.045L188.418 34.8355L188.233 35.687H188.196L188.048 34.8355L183.42 19.7315H176.609L184.124 40.7587H186.678L186.53 41.0919C185.826 42.9428 183.901 43.8313 181.199 44.6457L182.458 48.7919Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_207_7479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 2,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116.843,
    y: 2.31396,
    width: 13.8824,
    height: 13.8824,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_207_7479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.784 15.0393C122.984 15.0393 122.232 14.8875 121.528 14.5838C120.825 14.2801 120.212 13.868 119.692 13.3474C119.171 12.8268 118.759 12.2147 118.456 11.5109C118.152 10.8071 118 10.0552 118 9.25502C118 8.45485 118.152 7.70289 118.456 6.99913C118.759 6.29538 119.171 5.6832 119.692 5.16261C120.212 4.64203 120.825 4.22989 121.528 3.92622C122.232 3.62254 122.984 3.4707 123.784 3.4707C124.584 3.4707 125.336 3.62254 126.04 3.92622C126.744 4.22989 127.356 4.64203 127.877 5.16261C128.397 5.6832 128.809 6.29538 129.113 6.99913C129.417 7.70289 129.569 8.45485 129.569 9.25502C129.569 10.0552 129.417 10.8071 129.113 11.5109C128.809 12.2147 128.397 12.8268 127.877 13.3474C127.356 13.868 126.744 14.2801 126.04 14.5838C125.336 14.8875 124.584 15.0393 123.784 15.0393ZM123.206 13.8535V12.7256C122.888 12.7256 122.615 12.6123 122.389 12.3858C122.162 12.1592 122.049 11.8869 122.049 11.5687V10.9903L119.273 8.21384C119.244 8.38737 119.217 8.5609 119.193 8.73443C119.169 8.90796 119.157 9.08149 119.157 9.25502C119.157 10.4215 119.54 11.4434 120.306 12.3207C121.073 13.198 122.039 13.7089 123.206 13.8535ZM127.197 12.3785C127.39 12.1665 127.563 11.9375 127.718 11.6917C127.872 11.4458 128 11.1904 128.101 10.9252C128.202 10.6601 128.279 10.3878 128.332 10.1082C128.385 9.82863 128.412 9.54423 128.412 9.25502C128.412 8.31025 128.149 7.44742 127.624 6.66654C127.098 5.88565 126.397 5.32168 125.52 4.97462V5.206C125.52 5.52413 125.406 5.79648 125.18 6.02303C124.953 6.24958 124.681 6.36286 124.363 6.36286H123.206V7.51972C123.206 7.68361 123.15 7.82099 123.04 7.93186C122.929 8.04272 122.791 8.09815 122.627 8.09815H121.471V9.25502H124.941C125.105 9.25502 125.242 9.31045 125.353 9.42132C125.464 9.53218 125.52 9.66956 125.52 9.83345V11.5687H126.098C126.349 11.5687 126.575 11.6435 126.778 11.7929C126.98 11.9423 127.12 12.1375 127.197 12.3785Z",
    fill: "#00AFB5"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16.241L27.0405 0V10.6681L0 26.9087V16.241Z",
    fill: "#7880A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.081 16.241L27.0405 0V10.6681L54.081 26.9087V16.241Z",
    fill: "#F6F7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0405 32.6375L0 16.2407V42.603L27.0405 58.9997V32.6375Z",
    fill: "#DBCD86"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 27.3208L27.0405 43.7176V47.5341L0 31.1373V27.3208Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0406 32.6375L54.0811 16.2407V42.603L27.0406 58.9997V32.6375Z",
    fill: "#00AFB5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3881 31.9854L27.0405 43.7175V47.5339L46.3881 35.8018V31.9854Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1177 39.9119V30.0786L50.902 30.657L45.1177 39.9119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite15Logo);
export default __webpack_public_path__ + "static/media/website-15-logo.4f8bccac95222ec46be0ebd6d3a7280d.svg";
export { ForwardRef as ReactComponent };